export const UPGRADE_PATH = '/upgrade';
